import script from "./VirtualCourt.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualCourt.vue?vue&type=script&setup=true&lang=js"

import "./VirtualCourt.vue?vue&type=style&index=0&id=7aa57380&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aa57380"]])

export default __exports__